import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { createURL } from '@sm/utils';
import { TopBarSlim } from '../TopBarSlim';
import { UseCaseVariationEnums } from '../TopBarSlimEnums';

const DEFAULT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarSlim.message',
    defaultMessage:
      'Display quiz feedback based on answer accuracy. Then email the scores.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarSlim.ctaText',
    defaultMessage: 'See plans and pricing',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const COLLECT_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarSlim.messageCollect',
    defaultMessage:
      'See how all respondents scored with a plan that unlocks unlimited responses.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarSlim.ctaTextCollect',
    defaultMessage: 'See plans and pricing',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

const ANALYZE_COPY = defineMessages({
  MESSAGE: {
    id: 'UseCaseQuizzesAssessmentsTopBarSlim.messageAnalyze',
    defaultMessage:
      'Make more sense of your quiz results. Use Quizzes Pro for advanced export options.',
    description: '[Type: Paragraph][Vis.: low] - Top bar slim message',
  },
  CTA_TEXT: {
    id: 'UseCaseQuizzesAssessmentsTopBarSlim.ctaTextAnalyze',
    defaultMessage: 'See all plans',
    description: '[Type: Button][Vis.: low] - Top bar slim cta text',
  },
});

export type UseCaseQuizzesAssessmentsTopBarSlimProps = {
  variation?: UseCaseVariationEnums | null;
};

const VariationToCopy = {
  [UseCaseVariationEnums.create]: DEFAULT_COPY,
  [UseCaseVariationEnums.collect]: COLLECT_COPY,
  [UseCaseVariationEnums.analyze]: ANALYZE_COPY,
};

export const UseCaseQuizzesAssessmentsTopBarSlim: React.FC<UseCaseQuizzesAssessmentsTopBarSlimProps> = ({
  variation,
}) => {
  const copy =
    variation && variation in VariationToCopy
      ? VariationToCopy[variation]
      : DEFAULT_COPY;
  const ut_source = variation
    ? `slim_${variation}_upsell_quizzes_assessments`
    : 'slim_create_upsell_quizzes_assessments';

  return (
    <TopBarSlim
      message={t(copy.MESSAGE)}
      ctaText={t(copy.CTA_TEXT)}
      ctaLink={createURL('/pricing/upgrade/', {
        ut_source: 'topbar',
        ut_source2: ut_source,
      })}
      ctaNewTab
    />
  );
};

export default UseCaseQuizzesAssessmentsTopBarSlim;
